const setLocalStorageLogin = user_data => {
  localStorage.setItem('access_token', user_data.access_token);
  localStorage.setItem('csrf_token', user_data.csrf_token);
  localStorage.setItem('logout_token', user_data.logout_token);
  localStorage.setItem('user_data', JSON.stringify(user_data.current_user));
  localStorage.setItem('localstorage_login', 'true');
};

export default setLocalStorageLogin;
